import React, { useState } from 'react';
import { useQuery } from "react-query";
import { d3SingleMatchAPI } from "../shared/api/variables";
import { fetchClient } from "../shared/api/fetching";
import MatchStrip from "../mls-match-list/components/MatchStrip";
import { listTypes } from "../mls-match-list/utils";
import ErrorDisplay from "../shared/components/ErrorDisplay";
import HubMatchBlock from "./components/HubMatchBlock/HubMatchBlock";
import Picture from "../shared/components/Picture";
import { formatImageUrl } from "../shared/utils";
import MatchHubHeaderLoader from "./loader";
import { useReactAppState } from "../shared/containers/utils";

function MatchHubHeader({ options }) {
  const { match: appMatch, apiList, urlList } = useReactAppState();
  const {
    d3SportsAPI,
  } = apiList || {};
  const { venueBgUrl } = urlList || {};
  const matchSportecId = options.matchSportecId || appMatch?.sportecId;
  const [venue] = useState(options.venue || {});

  const matchEndpoint = d3SingleMatchAPI({ matchSportecId });

  const {
    isLoading: isLoadingMatch,
    isError: isErrorMatch,
    data: forgeMatch,
    error: matchError
  } = useQuery({
    queryKey: [`d3-match`, { matchSportecId }],
    queryFn: () => fetchClient({ endpoint: matchEndpoint, apiURL: d3SportsAPI })
  });

  const { backgroundImageUrl, venueOptaId } = venue || {};

  const { highQuality } = backgroundImageUrl
    ? formatImageUrl(backgroundImageUrl, { format: "f_auto", extension: "f_jpg" })
    : {};

  const backgroundImageSrc = highQuality ? highQuality : `${venueBgUrl}${venueOptaId ? `${venueOptaId}.jpg` : "default.jpg"}`;

  if (!matchSportecId) {
    return null;
  }

  return (
    isLoadingMatch
      ? <MatchHubHeaderLoader />
      : isErrorMatch
        ? (
          <div role="region" className={`mls-o-match-hub-header ${highQuality ? "mls-o-match-hub-header--background" : ""}`}>
            <ErrorDisplay error={matchError} />
          </div>
        )
        : (
          <div role="region" className={`mls-o-match-hub-header ${backgroundImageSrc ? "mls-o-match-hub-header--background" : ""}`}>
            <MatchStrip matchSportecId={matchSportecId} listType={listTypes.matches} forgeMatch={forgeMatch}>
              <HubMatchBlock />
              <div className="mls-o-match-hub-header__background">
                <Picture
                  loadingSrc={null}
                  fallbackSrc={`${venueBgUrl}default.jpg`}
                  src={backgroundImageSrc}
                  title={"background"} />
              </div>
            </MatchStrip>
          </div>
        )
  );
}

// eslint-disable-next-line no-func-assign
MatchHubHeader = React.memo(MatchHubHeader);

export default MatchHubHeader;
